import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconCardLandscape = function IconCardLandscape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 34"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#00204D",
    d: "M57.5.5v33H8.106V.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#00204D",
    d: "M38.484 10.608V33.5H4.603V10.608z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    stroke: "#00204D",
    d: "M21.75 18.878V33.5H.5V18.878z"
  }));
};